import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { scoutApi, errorMessage, type ScoutOffer } from './applicationStatusApi';
import { ConfirmDialog } from './applicationUi';

// 구직자가 받은 스카우트 제안 (응답 대기 건만) — 수락하면 제안받은 이력서로 지원이 접수된다
export default function ScoutOffersSection({ onAccepted }: { onAccepted?: () => void }) {
  const navigate = useNavigate();
  const [offers, setOffers] = useState<ScoutOffer[]>([]);
  const [pending, setPending] = useState<{ offer: ScoutOffer; accept: boolean } | null>(null);
  const [busy, setBusy] = useState(false);

  const load = () =>
    scoutApi
      .offers()
      .then((items) => setOffers(items.filter((o) => o.status === 'PENDING')))
      .catch(() => setOffers([]));

  useEffect(() => {
    load();
  }, []);

  const respond = async () => {
    if (!pending) return;
    setBusy(true);
    try {
      const result = await scoutApi.respond(pending.offer.id, pending.accept);
      setPending(null);
      await load();
      if (pending.accept) {
        onAccepted?.();
        if (result.applicationId) navigate(`/mypage/applications/${result.applicationId}`);
      }
    } catch (error) {
      setPending(null);
      alert(errorMessage(error));
      load();
    } finally {
      setBusy(false);
    }
  };

  if (!offers.length) return null;

  return (
    <section className="app-detail__notice app-detail__notice--offer" style={{ marginBottom: 16 }}>
      <strong>받은 스카우트 제안 {offers.length}건</strong>
      {offers.map((offer) => (
        <div key={offer.id} style={{ marginTop: 12, paddingTop: 12, borderTop: '1px solid #fde68a' }}>
          <div style={{ fontSize: 15, color: 'var(--ink-3)' }}>{[offer.job.church, offer.job.region].filter(Boolean).join(' · ')}</div>
          <div style={{ fontWeight: 700, margin: '2px 0 6px' }}>{offer.job.title}</div>
          {offer.message && <p style={{ whiteSpace: 'pre-line', marginBottom: 8 }}>“{offer.message}”</p>}
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
            {offer.job.path && (
              <button type="button" className="app-btn app-btn--small" onClick={() => navigate(offer.job.path!)}>
                공고 보기
              </button>
            )}
            <button type="button" className="app-btn app-btn--small" onClick={() => setPending({ offer, accept: false })}>
              거절
            </button>
            <button type="button" className="app-btn app-btn--small app-btn--accent" onClick={() => setPending({ offer, accept: true })}>
              수락하고 지원하기
            </button>
          </div>
        </div>
      ))}

      {pending && (
        <ConfirmDialog
          title={pending.accept ? '제안을 수락하고 지원할까요?' : '제안을 거절할까요?'}
          confirmLabel={pending.accept ? '수락하고 지원' : '거절'}
          danger={!pending.accept}
          busy={busy}
          onConfirm={respond}
          onCancel={() => setPending(null)}
        >
          {pending.accept ? (
            <p>제안받은 이력서로 {pending.offer.job.church || '교회'}에 지원이 접수됩니다. 이후 진행은 지원현황에서 확인할 수 있습니다.</p>
          ) : (
            <p>교회에 거절 알림이 전송됩니다.</p>
          )}
        </ConfirmDialog>
      )}
    </section>
  );
}
